var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import logo_dark from './assets/logo_dark.svg';
import { Box, FormField, Image, Input, LoaderButton, Select } from '@sproutsocial/racine';
import { DATE_OPTIONS } from './DateOptions';
/**
 * Store the last API token and date range selection that the user made.
 * @param connector
 */
var useConnectorState = function (connector) {
    var isConnectorInitialized = connector.isConnectorInitialized();
    var existingToken = isConnectorInitialized ? connector.getConnectionData().apiToken : '';
    var existingDateRange = isConnectorInitialized ? connector.getConnectionData().dateOptionKey : '';
    var _a = useState(existingToken), apiToken = _a[0], setApiToken = _a[1];
    var _b = useState(existingDateRange), dateRange = _b[0], setDateRange = _b[1];
    if (!isConnectorInitialized) {
        connector.registerConnectorInitCallback(function () {
            setApiToken(connector.getConnectionData().apiToken);
            setDateRange(connector.getConnectionData().dateOptionKey);
        });
    }
    return { apiToken: apiToken, dateRange: dateRange };
};
function App(_a) {
    var connector = _a.connector;
    var _b = useConnectorState(connector), existingToken = _b.apiToken, existingDateRange = _b.dateRange;
    var _c = useState(''), apiToken = _c[0], setApiToken = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), isError = _e[0], setIsError = _e[1];
    var _f = useState(''), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(''), dateRange = _g[0], setDateRange = _g[1];
    var isUpdating = existingDateRange && existingToken;
    var isSameAsExistingToken = apiToken.length > 0 && apiToken === existingToken;
    var getErrorText = function () {
        if (isSameAsExistingToken) {
            return 'Already connected. Enter a new API Key.';
        }
        if (errorMessage) {
            return errorMessage;
        }
        return 'Enter a valid API Key';
    };
    var handleSubmit = function () {
        setIsLoading(true);
        setIsError(false);
        setErrorMessage('');
        var currentApiToken = apiToken ? apiToken : existingToken || '';
        connector
            .validateApiToken(currentApiToken)
            .then(function () {
            connector.setApiToken(currentApiToken);
            connector.setDateOptionsKey(dateRange);
            connector.tableauSubmitEndOfInteractivePhase();
        })
            .catch(function (error) {
            setIsError(true);
            setIsLoading(false);
            // Set appropriate error message based on error type
            if (error.message === 'Invalid API Key') {
                setErrorMessage('Enter a valid API Key');
            }
            else if (error.message === 'Connection Error') {
                setErrorMessage('Connection failed. Please check your network and try again.');
            }
            else if (error instanceof SyntaxError) {
                setErrorMessage('Connection setup failed to parse connection data. Please clear your Tableau connection data or start a new Tableau workbook.');
            }
            else {
                setErrorMessage('An unexpected error occurred. Please try again.');
            }
        });
    };
    useEffect(function () {
        if (existingDateRange) {
            setDateRange(existingDateRange);
        }
    }, [existingDateRange]);
    return (_jsx("div", __assign({ className: 'App' }, { children: _jsxs(Box, __assign({ maxWidth: '600px', mt: 500, mx: 'auto', px: 600 }, { children: [_jsx(Image, { height: '34px', mb: 450, maxWidth: 'none', src: logo_dark, alt: 'Sprout Social' }), _jsx(FormField, __assign({ name: 'API_Key', "data-qa-label": 'api-key-input', label: 'API Key', isInvalid: isError || isSameAsExistingToken, error: getErrorText() }, { children: function (props) { return (_jsx(Input, __assign({ name: 'API_Key_Input', placeholder: existingToken || '', value: apiToken, onChange: function (e) { return setApiToken(e.target.value); }, required: true }, props))); } })), _jsx(FormField, __assign({ name: 'Date_Range', "data-qa-label": 'api-date-range-input', label: 'Date Range' }, { children: function (props) { return (_jsxs(Select, __assign({ name: 'Date_Range_select', value: dateRange, onChange: function (e) { return setDateRange(e.target.value); }, required: true }, props, { children: [_jsx("option", __assign({ value: '' }, { children: "Select Option" })), DATE_OPTIONS.map(function (dateOption) { return (_jsx("option", __assign({ value: dateOption.value }, { children: dateOption.label }), dateOption.value)); })] }))); } })), _jsx(LoaderButton, __assign({ disabled: !shouldEnableButton(), width: '100%', appearance: 'primary', isLoading: isLoading, onClick: handleSubmit, "data-qa-label": 'connect-button' }, { children: existingToken ? 'Update Connection' : 'Connect' }))] })) })));
    function shouldEnableButton() {
        if (isUpdating) {
            return (apiToken && !(apiToken === existingToken)) || (dateRange && !(dateRange === existingDateRange));
        }
        else {
            return apiToken && dateRange;
        }
    }
}
export default App;
